import React, {useState, useEffect} from 'react'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {IProfileDetails} from './SettingsModel'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import axios from 'axios'
import Swal from 'sweetalert2'
import {useNavigate} from 'react-router-dom'
import {initialQueryState, KTIcon, useDebounce} from '../../../../_metronic/helpers'

const profileDetailsSchema = Yup.object().shape({
  fName: Yup.string().required('First name is required'),
  lName: Yup.string().required('Last name is required'),
  code: Yup.string().required('code is required'),
  contactPhone: Yup.string().required('Contact phone is required'),
})

const ProfileDetailsSearch: React.FC = () => {
  const navigate = useNavigate()
  const API_URL = process.env.REACT_APP_API_URL
  const initialValues: IProfileDetails = {
    fName: '',
    lName: '',
    contactPhone: '',
    code: '',
    email: '',
  }
  const [data, setData] = useState<IProfileDetails>(initialValues)
  const updateData = (fieldsToUpdate: Partial<IProfileDetails>): void => {
    const updatedData = Object.assign(data, fieldsToUpdate)
    setData(updatedData)
  }

  const AlertError = (message: string) => {
    Swal.fire('', message, 'error')
  }
  useEffect(
    () => {},
    [] // Only re-call effect if value or delay changes
  )

  const uploadImage = async (e: any) => {
    if (e.target.files.length) {
      e.preventDefault()
      var _URL = window.URL || window.webkitURL
      var file = e.target.files[0]
      var formdata = new FormData()
      formdata.append('image', file)
      var requestOptions = {
        method: 'POST',
        body: formdata,
        redirect: 'follow',
      }
      const data = await axios.post(`${API_URL}/upload`, formdata)
    }
  }
  const [searchTerm, setSearchTerm] = useState<string>('')
  const [selectID, setSelectID] = useState<number>(0)
  const [poimt, setPoint] = useState<number>(0)

  const refreshAPISearch = async (search: string) => {
    setSearchTerm(search)
    const data = await axios
      .get(`${API_URL}/bo/participant/search/${search}`)
      .then((res) => {
        console.log(res.data.data)
        if (res.data.data) {
          formik.setFieldValue('fName', res.data.data.firstname)
          formik.setFieldValue('lName', res.data.data.lastname)
          formik.setFieldValue('contactPhone', res.data.data.mobile_number)
          formik.setFieldValue('code', res.data.data.code)
          formik.setFieldValue('email', res.data.data.email)
        }
      })
  }

  const AddPointAPI = async () => {
    const data = await axios
      .put(`${API_URL}/bo/participant/AddPoint`, {

      })
      .then((res) => {
        
      })
  }

  const [loading, setLoading] = useState(false)
  const formik = useFormik<IProfileDetails>({
    initialValues,
    validationSchema: profileDetailsSchema,
    onSubmit: (values) => {
      console.log(values)
      setLoading(true)
      setTimeout(async () => {
        //values.communications.email = data.communications.email
        //values.communications.phone = data.communications.phone
        //values.allowMarketing = data.allowMarketing
        const updatedData = Object.assign(data, values)
        setData(updatedData)
        Swal.fire({
          title: '',
          text: 'Confirm Edit',
          icon: 'info',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          showLoaderOnConfirm: true,
        }).then(async (result) => {
          if (result.isConfirmed) {
            const data0 = await axios
              .put(`${API_URL}/bo/participant/${1}`, {
                firstname: values.fName,
                lastname: values.lName,
                mobile_number: values.contactPhone,
              })
              .then(async (res) => {
                await Swal.fire('Success', 'Success', 'success')
                navigate(-1)
              })
              .catch((err) => {
                Swal.fire('Edit !', 'Your can not Edit. !! ' + err, 'error')
              })
          }
        })

        setLoading(false)
      }, 1000)
    },
  })

  return (
    <div className='card mb-5 mb-xl-10'>
      <div id='kt_account_profile_details' className='collapse show'>
        <form onSubmit={formik.handleSubmit} noValidate className='form'>
          <div className='card-body border-top p-9'>
            <div className='d-flex align-items-center position-relative my-1 mb-5'>
              <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
              <input
                type='text'
                data-kt-user-table-filter='search'
                className='form-control form-control-solid w-250px ps-14'
                placeholder='Search user'
                //value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <button
                className='btn btn-primary marginSetL'
                onClick={() => {
                  refreshAPISearch(searchTerm)
                }}
              >
                search
              </button>
            </div>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>Full Name</label>

              <div className='col-lg-8'>
                <div className='row'>
                  <div className='col-lg-6 fv-row'>
                    <input
                      disabled={true}
                      type='text'
                      className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                      placeholder='First name'
                      {...formik.getFieldProps('fName')}
                    />
                    {formik.touched.fName && formik.errors.fName && (
                      <div className='fv-plugins-message-container'>
                        {/*<div className='fv-help-block'>{formik.errors.fName}</div>*/}
                      </div>
                    )}
                  </div>

                  <div className='col-lg-6 fv-row'>
                    <input
                      disabled={true}
                      type='text'
                      className='form-control form-control-lg form-control-solid'
                      placeholder='Last name'
                      {...formik.getFieldProps('lName')}
                    />
                    {/*formik.touched.lName && formik.errors.lName && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>{formik.errors.lName}</div>
                      </div>
                    )*/}
                  </div>
                </div>
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>Mobile Number</label>

              <div className='col-lg-8 fv-row'>
                <input
                  disabled={true}
                  type='text'
                  className='form-control form-control-lg form-control-solid'
                  placeholder=''
                  {...formik.getFieldProps('contactPhone')}
                />
                {/*formik.touched.contactPhone && formik.errors.contactPhone && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.contactPhone}</div>
                  </div>
                )*/}
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>
                <span>Code</span>
              </label>

              <div className='col-lg-8 fv-row'>
                <input
                  disabled={true}
                  type='tel'
                  className='form-control form-control-lg form-control-solid'
                  placeholder=''
                  {...formik.getFieldProps('code')}
                />
                {/*formik.touched.code && formik.errors.code && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.code}</div>
                  </div>
                )*/}
              </div>
            </div>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>
                <span>Point</span>
              </label>

              <div className='col-lg-2 fv-row'>
                <input
                  //disabled={true}
                  type='number'
                  className='form-control form-control-lg form-control-solid'
                  placeholder=''
                  onChange={(e)=>setPoint(Number(e.target.value))}
                />
              </div>
              <div className='col-lg-2 fv-row'>
                <button
                  className='btn btn-primary'
                  onClick={() => {
                    AddPointAPI()
                    console.log('press')
                  }}
                >
                  Add Point
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

export {ProfileDetailsSearch}
